import { LoadingStatusType, PeakPayrollExceptionCode, TypeComponentNoti } from "@/enums/enums";
import { ConvertToImportEmployee } from "@/helper/employeeHelper";
import { GetExceptionsByExceptionCode } from "@/helper/exceptionCodeHelper";
import { ConvertToImportEmployeeTemplateList, GetImportEmployeeTemplate } from "@/helper/importHelper";
import { NewObject } from "@/helper/shareHelper";
import { MerchantId } from "@/helper/userHelper";
import { i18n } from "@/i18n";
import router from "@/router";
import API from "@/service/Index";
import { Action, Module, Mutation, VuexModule } from "vuex-module-decorators";

@Module({ namespaced: true })
export default class ImportEmployee extends VuexModule {
  private importEmployeeTemplateList: any = null;
  private updateImportEmployeeTemplateLoadingStatus: LoadingStatusType = LoadingStatusType.None;
  private importEmployeeLoadingStatus: LoadingStatusType = LoadingStatusType.None;

  get getImportEmployeeTemplateList(): any {
    return this.importEmployeeTemplateList;
  }
  get getUpdateImportEmployeeTemplateLoadingStatus(): LoadingStatusType {
    return this.updateImportEmployeeTemplateLoadingStatus;
  }
  get getImportEmployeeLoadingStatus(): LoadingStatusType {
    return this.importEmployeeLoadingStatus;
  }
  @Mutation
  public MutationImportEmployeeTemplate(importEmployeeTemplateList: any) {
    this.importEmployeeTemplateList = importEmployeeTemplateList;
  }

  @Mutation
  public MutationUpdateImportEmployeeTemplate(employeeTemplateList: any) {
    const importEmployeeTemplateList = NewObject(employeeTemplateList);
    importEmployeeTemplateList.forEach((employeeTemplate: any) => {
      this.importEmployeeTemplateList[employeeTemplate.id - 1] = employeeTemplate;
    });
  }
  @Mutation
  public MutationAddImportEmployeeTemplate() {
    let count = 0;
    if (this.importEmployeeTemplateList) {
      count = this.importEmployeeTemplateList.length;
    } else {
      this.importEmployeeTemplateList = [];
    }
    this.importEmployeeTemplateList.push(GetImportEmployeeTemplate(count + 1));
  }
  @Mutation
  public MutationDeleteImportEmployeeTemplate(id: any) {
    if (!this.importEmployeeTemplateList) {
      this.importEmployeeTemplateList = [];
    }
    this.importEmployeeTemplateList.splice(id - 1, 1);
  }
  @Mutation
  public MutationUpdateImportEmployeeTemplateLoadingStatus(status: LoadingStatusType) {
    this.updateImportEmployeeTemplateLoadingStatus = status;
  }

  @Mutation
  public MutationimportEmployeeLoadingStatus(status: LoadingStatusType) {
    this.importEmployeeLoadingStatus = status;
  }

  @Action
  public DoSetImportEmployeeTemplate(excelImportEmployeeJson: any) {
    if (excelImportEmployeeJson.length <= 200) {
      const importEmployeeTemplateList = ConvertToImportEmployeeTemplateList(excelImportEmployeeJson);
      this.context.commit("MutationImportEmployeeTemplate", importEmployeeTemplateList);
      router.push({ name: "importEmployeePreview", query: { emi: MerchantId().PeakEncryption() } });
    } else {
      this.context.dispatch(
        "Alert/SetAlertMessage",
        { alertMessage: "จำนวนพนักงานต้องไม่เกิน 200 คน", typeMessage: TypeComponentNoti.Error },
        { root: true }
      );
    }
  }
  @Action DoAddEmployee() {
    this.context.dispatch("Loading/IsLoading", true, { root: true });
    setTimeout(() => {
      this.context.commit("MutationAddImportEmployeeTemplate");
      this.context.dispatch("Loading/IsLoading", false, { root: true });
    }, 0);
  }
  @Action DoDeleteEmployee(id: number) {
    this.context.dispatch("Loading/IsLoading", true, { root: true });
    setTimeout(() => {
      this.context.commit("MutationDeleteImportEmployeeTemplate", id);
      this.context.dispatch("Loading/IsLoading", false, { root: true });
    }, 0);
  }
  @Action
  public UpdateImportEmployeeTemplate(input: any) {
    if (this.updateImportEmployeeTemplateLoadingStatus != LoadingStatusType.Loading) {
      if (input.isShowLoading) {
        this.context.dispatch("Loading/IsLoading", true, { root: true });
        this.context.commit("MutationUpdateImportEmployeeTemplateLoadingStatus", LoadingStatusType.Loading);
      } else {
        this.context.commit("MutationUpdateImportEmployeeTemplate", input.employeeTemplateList);
        this.context.commit("MutationUpdateImportEmployeeTemplateLoadingStatus", LoadingStatusType.Success);
      }
      setTimeout(() => {
        if (input.isShowLoading) {
          this.context.commit("MutationUpdateImportEmployeeTemplate", input.employeeTemplateList);
          this.context.commit("MutationUpdateImportEmployeeTemplateLoadingStatus", LoadingStatusType.Success);
          this.context.dispatch("Loading/IsLoading", false, { root: true });
        }
      }, 0);
    }
  }

  @Action
  public DoImportEmployee(importEmployeeTemplateList: any) {
    if (this.importEmployeeLoadingStatus !== LoadingStatusType.Loading) {
      this.context.commit("MutationimportEmployeeLoadingStatus", LoadingStatusType.Loading);
      this.context.dispatch("Loading/IsLoading", true, { root: true });
      API.EmployeeService.DoImportEmployee(ConvertToImportEmployee(importEmployeeTemplateList)).then(
        (resImportEmployee) => {
          const alert: any = {
            alertMessage: "",
            typeMessage: TypeComponentNoti.Success,
          };
          if (resImportEmployee.data.responseCode.IsSuccess()) {
            alert.alertMessage = i18n.t("Create_Employee_From_Import_Success");
            alert.typeMessage = TypeComponentNoti.Success;
            this.context.commit("Employee/MutationEmployeeLoadingStatus", LoadingStatusType.None, { root: true });
            this.context.commit("MutationimportEmployeeLoadingStatus", LoadingStatusType.Success);
            router.push({
              name: "employee",
              query: { emi: MerchantId().PeakEncryption() },
            });
          } else if (resImportEmployee.data.exception.code == PeakPayrollExceptionCode.CodeDuplicated) {
            let EmployeeCodeList = "";
            importEmployeeTemplateList.forEach((employeeTemplate: any) => {
              resImportEmployee.data.exception.content.forEach((content: string) => {
                if (employeeTemplate.code.value == content) {
                  employeeTemplate.code.validateError = true;
                  EmployeeCodeList = EmployeeCodeList + " #" + content;
                }
              });
            });
            alert.alertMessage = i18n.t("Exceptions_Notification.CodeDuplicated", {
              text: i18n.t("Employee") + EmployeeCodeList,
            });

            alert.typeMessage = TypeComponentNoti.Error;
            this.context.commit("MutationimportEmployeeLoadingStatus", LoadingStatusType.None);
          } else {
            alert.alertMessage = GetExceptionsByExceptionCode(resImportEmployee.data.exception);
            alert.typeMessage = TypeComponentNoti.Error;
            this.context.commit("MutationimportEmployeeLoadingStatus", LoadingStatusType.None);
          }

          this.context.dispatch("Loading/IsLoading", false, { root: true });
          this.context.dispatch("Alert/SetAlertMessage", alert, { root: true });
        }
      );
    }
  }
}
